import { JedinicaMere } from './jedinica-mere';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'yt-jedinica-mere-modal-update',
  templateUrl: './jedinica-mere-modal-update.component.html'
  //styleUrls: ['./jedinica-mere-modal-update.component.scss']
})
export class JedinicaMereModalUpdateComponent extends BaseModalUpdateComponent<JedinicaMere> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<JedinicaMere>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
